export const DRIVER_PORTAL_LIVE_SYNC_POLL_INTERVAL_MS = 15000;

function buildAssignmentOperationalSignature(assignments) {
  return (Array.isArray(assignments) ? assignments : [])
    .map((assignment) => {
      const steps = Array.isArray(assignment?.operational_steps) ? assignment.operational_steps : [];
      return steps.map((step) => [
        step.step_id,
        step.step_type,
        step.sequence,
        step.order_id,
        step.delivery_id,
        step.quantity_tons,
        step.is_confirmed,
        step.is_loading_confirmed,
        step.confirmation_portail,
        step.publication_revision,
      ].join(":")).join("|");
    })
    .join("||");
}

export function buildDriverPortalLiveSyncFingerprint(payload) {
  if (!payload || typeof payload !== "object") {
    return "";
  }

  const planningSummary = payload.planning_summary && typeof payload.planning_summary === "object"
    ? payload.planning_summary
    : {};
  const updatedAt = typeof planningSummary.updated_at === "string" ? planningSummary.updated_at.trim() : "";
  const deliveryConfirmedCount = Number(planningSummary.delivery_confirmed_count) || 0;
  const confirmedCount = Number(planningSummary.confirmed_count) || 0;
  const assignmentSignature = buildAssignmentOperationalSignature(payload.assignments);
  const dispatchPeriod = typeof payload.dispatch_period === "string" ? payload.dispatch_period.trim() : "";
  const publicationRevision = Number(payload.publication_revision) || 0;
  const publicationRevisions = payload.publication_revisions && typeof payload.publication_revisions === "object"
    ? Object.entries(payload.publication_revisions)
        .map(([truckId, revision]) => `${truckId}:${Number(revision) || 0}`)
        .sort()
        .join("|")
    : "";
  const dispatchDisabledTruckIds = Array.from(new Set(
    (Array.isArray(payload.dispatch_disabled_truck_ids) ? payload.dispatch_disabled_truck_ids : [])
      .map((truckId) => typeof truckId === "string" ? truckId.trim() : "")
      .filter(Boolean),
  )).sort().join("|");

  const departures = [payload.departure_simulation_available, ...(payload.departure_stops || []).map((stop) => [stop.truck_id, stop.visit_key, stop.version, stop.departure, stop.can_cancel, stop.locked, stop.is_simulated, stop.planned_departure].join(":"))].sort().join("|");
  return `${dispatchPeriod}::${publicationRevision}::${publicationRevisions}::${dispatchDisabledTruckIds}::${updatedAt}::${deliveryConfirmedCount}::${confirmedCount}::${assignmentSignature}::${departures}`;
}
